/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./screen-group-item.vue?vue&type=template&id=7389d9bf&scoped=true&"
import script from "./screen-group-item.vue?vue&type=script&lang=ts&"
export * from "./screen-group-item.vue?vue&type=script&lang=ts&"
import style0 from "./screen-group-item.vue?vue&type=style&index=0&id=7389d9bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7389d9bf",
  null
  
)

export default component.exports